var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningCircle = function SvgWarningCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31,
    viewBox: "0 0 32 31"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728",
    transform: "translate(-534.113 -909.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729",
    transform: "translate(543.399 917.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_728-2",
    "data-name": "Group 728"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(-0.286 -0.286)",
    fill: "none",
    stroke: "#dd4545",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M214.431,71.961a.773.773,0,0,1,.835-.788.786.786,0,0,1,.835.788v4.465a.786.786,0,0,1-.835.788.774.774,0,0,1-.835-.788Zm-.07,6.841a.9.9,0,1,1,.9.9.905.905,0,0,1-.9-.9",
    transform: "translate(-208.133 -68.226)",
    fill: "#dd4545"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    width: 32,
    height: 31,
    transform: "translate(534.113 909.113)",
    fill: "none"
  }))));
};
export default SvgWarningCircle;